var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChiudi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9999 74.9C71.1999 74.9 70.4999 74.6 69.8999 74L25.9999 30.2C24.7999 29 24.7999 27.1 25.9999 26C27.1999 24.8 29.0999 24.8 30.1999 26L74.0999 69.9C75.2999 71.1 75.2999 73 74.0999 74.1C73.5999 74.7 72.7999 74.9 71.9999 74.9Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 74.9C27.3998 74.9 26.6998 74.6 26.0998 74C24.8998 72.8 24.8998 70.9 26.0998 69.8L69.9998 25.9C71.1998 24.7 73.0998 24.7 74.1998 25.9C75.3998 27.1 75.3998 29 74.1998 30.1L30.2998 74.1C29.6998 74.7 28.8998 74.9 28.1998 74.9Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiudi);
export default __webpack_public_path__ + "static/media/chiudi.905c47e4fe12e49a33e7cfa287525698.svg";
export { ForwardRef as ReactComponent };